<template>
<div>
  <div v-if="invoicee" class="form-container">
    <div class="col">
      <h2>{{invoicee.name}}</h2>
      <ul class="form-specifics">
        <li>{{$t("b2c.apixId")}}: {{invoicee.apixId}}</li>
      </ul>
      <div v-for="(arr, key) in keys" :key="key" class="row">
        <div v-for="(formpart, key) in arr" class="col-xs-12 col-lg-6" :key="key+'-form-part'">
          <div class="form-group">
            <label class="form-label">{{$t("b2c."+formpart)}}</label>
            <input
              class="form-control form-control-sm"
              :class="{
                    '':validation[formpart] === undefined || null,
                  'is-invalid': validation[formpart] === false,
                  'is-valid': validation[formpart]
                }"
              v-model.trim="invoicee[formpart]"
              :placeholder="$t('b2c.'+formpart)"
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <button @click="$router.push({name:'invoices'})" class="btn btn-button-success float-left">{{$t("common.back")}}</button>
          <button :disabled="!valid" @click="updateInvoicee" class="btn btn-button-success float-right">{{$t("b2c.save")}}</button>
        </div>
      </div>
    </div>
  </div>
  <div class="mt-5" v-if="notFound">
    <h2 class="text-error">{{$t("b2c.notFound")}}</h2>
  </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      notFound: false,
      id: null,
      orig: null,
      invoicee: null,
      keys: [
        // ["idInvoicee"],
        ["name"],
        ["address1", "address2"],
        ["city", "postCode"]
        //     ["country"],
        //    ["createdAt", "updatedAt", "receivedInvoices", "comment"]
      ],
      validation: {
        name: null,
        address1: null,
        city: null,
        postCode: null
      }
    };
  },

  mounted: function() {
    this.getInvoicee(this.$route.params.id);
  },
  methods: {
    updateInvoicee: async function() {
      try {
        let res = await this.$store.dispatch("updateInvoicee", {
          address1: this.invoicee.address1,
          address2: this.invoicee.address2 === null ? "" : this.invoicee.address2,
          postCode: this.invoicee.postCode,
          name: this.invoicee.name,
          city: this.invoicee.city,
          idInvoicee: this.invoicee.idInvoicee
        });
        this.$router.push({
          name: "invoicee",
          params: { idInvoicee: res.id, id: res.apixId }
        });
        this.getInvoicee(res.apixId);
      } catch (error) {
        console.log(error);
        this.$notify({
        text: this.$t("b2c.errorUpdating"),
        type: "error",
        duration: 3000,
      })
      }
    },
    getInvoicee: async function(id) {
      try {
        let invoicee = await this.$store.dispatch("getInvoicee", id);
        this.invoicee = invoicee;
        this.orig = Object.assign({}, invoicee)
        this.notFound = false
      } catch (error) {
        console.log(error);
        this.notFound = true
        this.invoicee = null
        this.orig = null
      }
    }
  },
  computed: {
    valid: function() {
      let changed = false;
      Object.keys(this.validation).forEach(k => {
        if (!this.validation[k]) {
          return false;
        }
        if (this.invoicee[k] !== this.orig[k]) {
          changed = true;
        }
      });
      if (this.invoicee.address2 !== this.orig.address2) {
        changed = true;
      }
      return changed;
    }
  },

  watch: {
    $route: function(to, from) {
      if (to.params.invoiceeId && to.params.invoiceeId !== this.id) {
        this.getInvoicee(to.params.id);
      }
    },
    invoicee: {
      handler: function(val) {
        if (val) {
          Object.keys(this.validation).forEach(k => {
            this.validation[k] = val[k].length > 0;
          });
        }
      },
      deep: true,
      immediate: true
    }
  }
};
</script>

<style scoped>
.form-container {
  max-width: 600px;
  margin: auto;
  color: #0B0B14;
}
.is-valid {
  border-color: #0F8A71;
}
.is-valid:focus {
  box-shadow: 0 0 5px #0F8A71;
}
.form-label {
  float: left;
}
.form-specifics {
  text-align: left;
}
.form-updated-at {
  margin-top: 3em;
  font-style: italic;
  opacity: 0.5;
}
</style>